import AWS from "aws-sdk";

const REACT_APP_AWS_ACCESS_KEY_ID = "AKIAZPPCMDIZB65WYTVX";
const REACT_APP_AWS_SECRET_ACCESS_KEY =
  "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";

export default async function handlePdfDownload(key, ext) {
  AWS.config.update({
    accessKeyId: REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: REACT_APP_AWS_SECRET_ACCESS_KEY,
  });
  const s3 = new AWS.S3();

  const params = {
    Bucket: `mysite-po-pdfs`,
    Key: `${key}.${ext}`,
  };

  function downloadBlob(blob, name = `${key}.${ext}`) {
    // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
    const blobUrl = URL.createObjectURL(blob);
    // Create a link element
    const link = document.createElement("a");
    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = name;
    // Append link to the body
    document.body.appendChild(link);
    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    // Remove link from body
    document.body.removeChild(link);
  }
  let types = {
    pdf: "application/pdf",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    rar: "application/vnd.rar",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xls: "application/vnd.ms-excel",
    zip: "application/zip",
    txt: "text/plain",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    doc: "application/msword",
    csv: "text/csv",
  };
  s3.getObject(params, (err, data) => {
    if (err) {
      console.log(err, err.stack);
    } else {
      let csvBlob = new Blob([data.Body], {
        type: `${types[ext]};charset=utf-8;`,
      });
      downloadBlob(csvBlob, `${key}`);
    }
  });
}
